export default __webpack_public_path__ + "static/media/ret-roof.c12c025e.jpg";